import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Backdrop,
  CircularProgress,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styled from "styled-components";
import StyledTextField from "./StyledTextField";
import api from "../../api/config";
import { UpdateUser } from "../../api/Users";
import { useNotification } from "../../context/NotificationContext";

const Header = styled(DialogTitle)`
  background-color: #28929c;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
`;

const Content = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px !important;
  background-color: #2b3342;
  color: white;
`;

export default function EditUserModal({
  open,
  onClose,
  user = {},
  accessLevels = [],
  clients = [],
  onSaveSuccess = () => {},
}) {
  const [firstName, setFirstName] = useState(user.first_name || "");
  const [lastName, setLastName] = useState(user.last_name || "");
  const [email, setEmail] = useState(user.email || "");
  const [phoneNumber, setPhoneNumber] = useState(user.phone_number || "");
  const [accessLevel, setAccessLevel] = useState(user.access_level || "");
  const [clientUuid, setClientUuid] = useState(user.organization_uuid || "");
  const [clientName, setClientName] = useState(user.organization || "");
  const [loading, setLoading] = useState(false);
  const { showNotification } = useNotification();

  useEffect(() => {
    setFirstName(user.first_name || "");
    setLastName(user.last_name || "");
    setEmail(user.email || "");
    setPhoneNumber(user.phone_number || "");
    setAccessLevel(user.access_level || "");
    setClientUuid(user.organization_uuid || "");
    setClientName(user.organization || "");
  }, [user]);

  const handleSave = async () => {
    const payload = {
      email,
      first_name: firstName,
      last_name: lastName,
      access_level: accessLevel,
      phone_number: phoneNumber,
      organization: clientName,
      organization_uuid: clientUuid,
    };

    setLoading(true);
    try {
      const response = await api.put(`${UpdateUser}`, payload);
      console.log("User updated successfully", response);
      onSaveSuccess();
    } catch (error) {
      console.error("Error updating user:", error);
      showNotification("Error updating user", "error");
    }
    setLoading(false);
  };

  // const transformedAccessLevels = accessLevels.map((item) => ({
  //   label: item.name,
  //   value: item.name,
  // }));

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <Header>
        Edit User - {email}
        <IconButton onClick={onClose} style={{ color: "white" }}>
          <CloseIcon />
        </IconButton>
      </Header>
      <Content>
        <StyledTextField
          label="First Name"
          variant="outlined"
          fullWidth
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
        <StyledTextField
          label="Last Name"
          variant="outlined"
          fullWidth
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />
        <StyledTextField
          label="Email"
          variant="outlined"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <StyledTextField
          label="Phone Number"
          variant="outlined"
          fullWidth
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
        />

        {/* <Autocomplete
          options={transformedAccessLevels}
          getOptionLabel={(option) => option.label || ""}
          value={
            transformedAccessLevels.find((al) => al.value === accessLevel) ||
            null
          }
          onChange={(event, newValue) => {
            setAccessLevel(newValue ? newValue.value : "");
          }}
          renderInput={(params) => (
            <StyledTextField
              {...params}
              label="Access Level"
              variant="outlined"
              sx={{ marginTop: "16px" }}
            />
          )}
          componentsProps={{
            paper: {
              sx: {
                backgroundColor: "#141b25",
                color: "#FBFEFF",
                maxHeight: 300,
              },
            },
          }}
        /> */}

        {/* <Autocomplete
          options={clients}
          getOptionLabel={(option) => option.npi_name || ""}
          value={clients.find((c) => c.uuid === clientUuid) || null}
          onChange={(event, newValue) => {
            if (newValue) {
              setClientUuid(newValue.uuid);
              setClientName(newValue.npi_name);
            } else {
              setClientUuid("");
              setClientName("");
            }
          }}
          renderInput={(params) => (
            <StyledTextField
              {...params}
              label="Client / Organization"
              variant="outlined"
              sx={{ marginTop: "16px" }}
            />
          )}
          componentsProps={{
            paper: {
              sx: {
                backgroundColor: "#141b25",
                color: "#FBFEFF",
                maxHeight: 300,
              },
            },
          }}
        /> */}
      </Content>

      <DialogActions sx={{ backgroundColor: "#28929c" }}>
        <Button onClick={handleSave} color="primary" variant="contained">
          Save
        </Button>
      </DialogActions>

      <Backdrop open={loading} style={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  );
}
